// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as OauthCompleteRouteImport } from './routes/oauth-complete'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LinkMinecraftRouteImport } from './routes/link/minecraft'
import { Route as DocsSplatRouteImport } from './routes/docs/$'

const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const OauthCompleteRoute = OauthCompleteRouteImport.update({
            id: '/oauth-complete',path: '/oauth-complete',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ErrorRoute = ErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LinkMinecraftRoute = LinkMinecraftRouteImport.update({
            id: '/link/minecraft',path: '/link/minecraft',getParentRoute: () => rootRouteImport
          })
const DocsSplatRoute = DocsSplatRouteImport.update({
            id: '/docs/$',path: '/docs/$',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ErrorRoute: ErrorRoute,LoginRoute: LoginRoute,OauthCompleteRoute: OauthCompleteRoute,ProfileRoute: ProfileRoute,RegisterRoute: RegisterRoute,SettingsRoute: SettingsRoute,DocsSplatRoute: DocsSplatRoute,LinkMinecraftRoute: LinkMinecraftRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)